import React from 'react';
import atlaslogo from './Atlas-Final Logo (1).png';

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="contact" style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '64px 0 40px', background: '#0a0f1e' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 32px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '48px', marginBottom: '56px' }} className="footer-grid">
          {/* Brand */}
          <div>
            <div
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '16px',
  }}
>
  <img
    src={atlaslogo}
    alt="ATLAS Logo"
    style={{
      width: '42px',
      height: '45px',
      borderRadius: '8px',
    }}
  />

  <div>
    <div
      style={{
        fontFamily: "'Space Grotesk', sans-serif",
        fontWeight: 700,
        fontSize: '20px',
        letterSpacing: '-0.5px',
      }}
    >
      ATLAS ITSM
    </div>

    <div
      style={{
        fontSize: '11px',
        color: '#5a6a8a',
        fontWeight: 400,
        letterSpacing: '0.05em',
      }}
    >
      by Aiprus Software
    </div>
  </div>
</div>
            <p style={{ fontSize: '14px', color: '#5a6a8a', lineHeight: 1.7, maxWidth: '260px' }}>
              Enterprise IT Service Management built for transparent, efficient, and fair service delivery.
            </p>
            {/* <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              {['LinkedIn', 'Twitter', 'GitHub'].map(s => (
                <div key={s} style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '8px', fontSize: '12px', color: '#5a6a8a', cursor: 'pointer' }}>{s}</div>
              ))}
            </div> */}
          </div>

          {/* Product */}
          <div>
            <div style={{ fontSize: '12px', color: '#52b788', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '20px' }}>Product</div>
            {['Features', 'Modules', 'Data Sheet', 'Technical Specifications', 'Implementation', 'Use Cases', 'Architecture', 'Pricing'].map(l => (
              <div key={l} style={{ fontSize: '14px', color: '#5a6a8a', marginBottom: '12px', cursor: 'pointer', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#a8b4cc'}
                onMouseLeave={e => e.target.style.color = '#5a6a8a'}
                onClick={() => scrollTo(l.toLowerCase().replace(/ /g, '-'))}>
                {l}
              </div>
            ))}
          </div>

          {/* Company */}
          <div>
            <div style={{ fontSize: '12px', color: '#52b788', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '20px' }}>Company</div>
            {['About Aiprus', 'Blog', 'Careers', 'Privacy Policy', 'Terms of Service'].map(l => (
              <div key={l} style={{ fontSize: '14px', color: '#5a6a8a', marginBottom: '12px', cursor: 'pointer', transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#a8b4cc'}
                onMouseLeave={e => e.target.style.color = '#5a6a8a'}>
                {l}
              </div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <div style={{ fontSize: '12px', color: '#52b788', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '20px' }}>Contact</div>
            {[
              { label: 'Email', value: 'contact@aiprus.com' },
              { label: 'Website', value: 'www.aiprus.com' },
              { label: 'Support', value: 'support@aiprus.com' },
            ].map(c => (
              <div key={c.label} style={{ marginBottom: '16px' }}>
                <div style={{ fontSize: '11px', color: '#5a6a8a', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '3px' }}>{c.label}</div>
                <div style={{ fontSize: '14px', color: '#a8b4cc' }}>{c.value}</div>
              </div>
            ))}
            <button onClick={() => scrollTo('book-a-demo')} style={{ marginTop: '8px', background: 'linear-gradient(135deg, #2d6a4f, #40916c)', color: '#fff', padding: '10px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, border: 'none', cursor: 'pointer', width: '100%' }}>
              Book a Demo
            </button>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ fontSize: '13px', color: '#5a6a8a' }}>© 2026 Aiprus Software. All rights reserved.</div>
          <div style={{ fontSize: '13px', color: '#5a6a8a' }}></div>
        </div>
      </div>
      <style>{`@media(max-width:900px){ .footer-grid{ grid-template-columns:1fr 1fr !important; } } @media(max-width:580px){ .footer-grid{ grid-template-columns:1fr !important; } }`}</style>
    </footer>
  );
}
